( function( global, $ ) {
    var $showroomsFormTarget = $('#reservation-form');
    var $showroomsFormSelect = $('[data-showroom-form-select]');

    // redirection des CTA des salles de montres vers la section formulaire
    // avec préselection du select
    if ($showroomsFormTarget) {
        $('[data-showroom-cta]').each(function(){
            $(this).click(function(e) {
                e.preventDefault();
                $(window).scrollTop(($showroomsFormTarget).offset().top);

                if($showroomsFormSelect) {
                    $showroomsFormSelect.find('option').removeAttr('selected')
                    var target = $showroomsFormSelect.find('option[data-identifier='+ $(this).attr('data-showroom-cta') +']');
                    target.attr('selected', 'selected');                    
                }
            })
        });
    }

    // au chargement, si une salle est renseignée dans l'url --> scroll vers le formulaire
    var urlParams = new URLSearchParams(window.location.search); // eslint-disable-line no-undef

    if ( urlParams.get('showroom') && urlParams.get('showroom').length > 0) {
        $(window).scrollTop(($showroomsFormTarget).offset().top);
    }

}( window.groots, jQuery ));
